
import { Component, Vue } from 'vue-property-decorator';
import HeaderComponent from '@/components/HeaderComponent.vue';
import FooterComponent from '@/components/FooterComponent.vue';
import Modal from "@/components/Modal.vue";
import { api } from "./Api";
import SavedResponseGroup from "./components/SavedResponseGroup.vue";
import CountrySelector from "./components/CountrySelector.vue";

@Component({
    components: {
        SavedResponseGroup,
        HeaderComponent,
        FooterComponent,
        Modal,
        CountrySelector,
    },
})
export default class App extends Vue {

    setViewportWidth() {
        this.$store.commit('setWideScreen', Math.max(document.documentElement.clientWidth, window.innerWidth || 0));
    }


    knowUser() {
        localStorage.setItem('knownUser', 'true')
        this.$store.state.knownUser = true
    }
    async mounted() {
        console.log(this.$store.state.knownUser)
        const searchURL = new URL(window.location as any);
        let queryString = window.location.search;
        let urlParams = new URLSearchParams(queryString);
        if (urlParams.has('source')) {
            const source = urlParams.get('source')
            if (source) {
                const data = await api.getPartnerInfos(source)
                if (data.data.status === 'success') {
                    sessionStorage.setItem('partner', source)
                }
            }
        }
        const partner = sessionStorage.getItem('partner')
        if (partner) {
            this.$store.state.partner = partner
        }
        // console.log(this.$store.state.partner)
        this.setViewportWidth();
        window.addEventListener('resize', () => this.setViewportWidth());
        // await this.$router.onReady(() => {
        //     console.log(this.$route.query.source)
        // })

    }
}
